import { render } from "./DimensionsInput.vue?vue&type=template&id=ffb999f0&scoped=true"
import script from "./DimensionsInput.vue?vue&type=script&lang=js"
export * from "./DimensionsInput.vue?vue&type=script&lang=js"

import "./DimensionsInput.vue?vue&type=style&index=0&id=ffb999f0&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ffb999f0"]])

export default __exports__